import React, { useState, useEffect, useCallback } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaImage, FaVideo, FaPlay, FaArrowRight, FaTimes, FaChevronLeft, FaChevronRight, FaCalendarAlt, FaFilter } from 'react-icons/fa';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';

function GalleryPage() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('all');
  const [activeEvent, setActiveEvent] = useState('all');
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);

  // تصاویر همایش روز اول - ۲۱ آبان ۱۴۰۴
  const day1Images = [
    { type: 'image', url: 'https://i.postimg.cc/NjMPzMs8/IMG-20251113-WA0000.jpg', alt: 'همایش افتتاحیه - ۲۱ آبان', event: 'day1' },
    { type: 'image', url: 'https://i.postimg.cc/9QFvHbpy/IMG-20251113-WA0001.jpg', alt: 'همایش افتتاحیه - ۲۱ آبان', event: 'day1' },
    { type: 'image', url: 'https://i.postimg.cc/JzpCsvnq/IMG-20251113-WA0002.jpg', alt: 'همایش افتتاحیه - ۲۱ آبان', event: 'day1' },
    { type: 'image', url: 'https://i.postimg.cc/jdQbbLrs/IMG-20251113-WA0003.jpg', alt: 'همایش افتتاحیه - ۲۱ آبان', event: 'day1' },
    { type: 'image', url: 'https://i.postimg.cc/dVsKtwqD/IMG-20251113-WA0004.jpg', alt: 'همایش افتتاحیه - ۲۱ آبان', event: 'day1' },
    { type: 'image', url: 'https://i.postimg.cc/xTQwtnNR/IMG-20251113-WA0005.jpg', alt: 'همایش افتتاحیه - ۲۱ آبان', event: 'day1' },
    { type: 'image', url: 'https://i.postimg.cc/xdFQ4hVn/IMG-20251113-WA0006.jpg', alt: 'همایش افتتاحیه - ۲۱ آبان', event: 'day1' },
    { type: 'image', url: 'https://i.postimg.cc/qRhrVwp2/IMG-20251113-WA0007.jpg', alt: 'همایش افتتاحیه - ۲۱ آبان', event: 'day1' },
    { type: 'image', url: 'https://i.postimg.cc/yYzHt0tj/IMG-20251113-WA0010.jpg', alt: 'همایش افتتاحیه - ۲۱ آبان', event: 'day1' },
    { type: 'image', url: 'https://i.postimg.cc/LssRvR7x/IMG-20251113-WA0011-1.jpg', alt: 'همایش افتتاحیه - ۲۱ آبان', event: 'day1' },
    { type: 'image', url: 'https://i.postimg.cc/50Tx6GPV/IMG-20251114-WA0002.jpg', alt: 'همایش افتتاحیه - ۲۱ آبان', event: 'day1' },
    { type: 'image', url: 'https://i.postimg.cc/dVwJkG9Z/IMG-20251114-WA0003.jpg', alt: 'همایش افتتاحیه - ۲۱ آبان', event: 'day1' },
    { type: 'image', url: 'https://i.postimg.cc/vHXNh9dp/IMG-20251114-WA0004.jpg', alt: 'همایش افتتاحیه - ۲۱ آبان', event: 'day1' },
    { type: 'image', url: 'https://i.postimg.cc/x1xBfmxy/IMG-20251114-WA0006.jpg', alt: 'همایش افتتاحیه - ۲۱ آبان', event: 'day1' }
  ];

  // تصاویر همایش روز دوم - ۲۸ آبان ۱۴۰۴ (کمپ باور)
  const day2Images = [
    { type: 'image', url: 'https://i.postimg.cc/gJNSxJjL/IMG-20251119-WA0005.jpg', alt: 'روز دوم کمپ باور - ۲۸ آبان', event: 'day2' },
    { type: 'image', url: 'https://i.postimg.cc/MTdPnTHV/IMG-20251130-WA0001.jpg', alt: 'روز دوم کمپ باور - ۲۸ آبان', event: 'day2' },
    { type: 'image', url: 'https://i.postimg.cc/MTdPnTH7/IMG-20251130-WA0002.jpg', alt: 'روز دوم کمپ باور - ۲۸ آبان', event: 'day2' },
    { type: 'image', url: 'https://i.postimg.cc/qRjbNRq2/IMG-20251130-WA0003.jpg', alt: 'روز دوم کمپ باور - ۲۸ آبان', event: 'day2' },
    { type: 'image', url: 'https://i.postimg.cc/SsDTnsRW/IMG-20251130-WA0004.jpg', alt: 'روز دوم کمپ باور - ۲۸ آبان', event: 'day2' },
    { type: 'image', url: 'https://i.postimg.cc/6qqHnX4C/IMG-20251202-WA0002.jpg', alt: 'روز دوم کمپ باور - ۲۸ آبان', event: 'day2' },
    { type: 'image', url: 'https://i.postimg.cc/50n7X0yn/IMG-20251202-WA0003.jpg', alt: 'روز دوم کمپ باور - ۲۸ آبان', event: 'day2' },
    { type: 'image', url: 'https://i.postimg.cc/gJNSxJjD/IMG-20251202-WA0004.jpg', alt: 'روز دوم کمپ باور - ۲۸ آبان', event: 'day2' },
    { type: 'image', url: 'https://i.postimg.cc/0QcWzQjZ/IMG-20251202-WA0005.jpg', alt: 'روز دوم کمپ باور - ۲۸ آبان', event: 'day2' },
    { type: 'image', url: 'https://i.postimg.cc/SRRZChYC/IMG-20251202-WA0006.jpg', alt: 'روز دوم کمپ باور - ۲۸ آبان', event: 'day2' },
    { type: 'image', url: 'https://i.postimg.cc/4dBLYdyP/IMG-20251202-WA0007.jpg', alt: 'روز دوم کمپ باور - ۲۸ آبان', event: 'day2' }
  ];

  // تصاویر کمپ ۱۲ آذر و اختتامیه
  const day3Images = [
    { type: 'image', url: 'https://i.postimg.cc/CxLvP2NG/IMG-20251203-WA0014.jpg', alt: 'کمپ ۱۲ آذر و اختتامیه', event: 'day3' },
    { type: 'image', url: 'https://i.postimg.cc/6p5HjP0G/IMG-20251203-WA0015.jpg', alt: 'کمپ ۱۲ آذر و اختتامیه', event: 'day3' },
    { type: 'image', url: 'https://i.postimg.cc/kXy1yCx4/IMG-20251203-WA0017.jpg', alt: 'کمپ ۱۲ آذر و اختتامیه', event: 'day3' },
    { type: 'image', url: 'https://i.postimg.cc/CL0rD5fS/IMG-20251203-WA0019.jpg', alt: 'کمپ ۱۲ آذر و اختتامیه', event: 'day3' },
    { type: 'image', url: 'https://i.postimg.cc/ryxYKxsr/IMG-20251203-WA0021.jpg', alt: 'کمپ ۱۲ آذر و اختتامیه', event: 'day3' },
    { type: 'image', url: 'https://i.postimg.cc/8kMnjMcw/IMG-20251203-WA0023.jpg', alt: 'کمپ ۱۲ آذر و اختتامیه', event: 'day3' },
    { type: 'image', url: 'https://i.postimg.cc/VLwZMv04/IMG-20251203-WA0025.jpg', alt: 'کمپ ۱۲ آذر و اختتامیه', event: 'day3' },
    { type: 'image', url: 'https://i.postimg.cc/SN418RYD/IMG-20251203-WA0027.jpg', alt: 'کمپ ۱۲ آذر و اختتامیه', event: 'day3' },
    { type: 'image', url: 'https://i.postimg.cc/J43gdZCv/IMG-20251203-WA0029.jpg', alt: 'کمپ ۱۲ آذر و اختتامیه', event: 'day3' },
    { type: 'image', url: 'https://i.postimg.cc/3xJLSqBC/IMG-20251203-WA0031.jpg', alt: 'کمپ ۱۲ آذر و اختتامیه', event: 'day3' },
    { type: 'image', url: 'https://i.postimg.cc/vZq0pv2y/IMG-20251203-WA0033.jpg', alt: 'کمپ ۱۲ آذر و اختتامیه', event: 'day3' },
    { type: 'image', url: 'https://i.postimg.cc/ZqWwZyXT/IMG-20251203-WA0035.jpg', alt: 'کمپ ۱۲ آذر و اختتامیه', event: 'day3' },
    { type: 'image', url: 'https://i.postimg.cc/RZsgjTp9/IMG-20251203-WA0037.jpg', alt: 'کمپ ۱۲ آذر و اختتامیه', event: 'day3' }
  ];

  const eventVideos = [
    { type: 'video', url: 'https://customer-assets.emergentagent.com/job_24dae199-66e7-4e77-8ffd-deeb363828c0/artifacts/sijbu381_VID-20251114-WA0009.mp4', alt: 'ویدیو همایش ۲۱ آبان', thumbnail: 'https://i.postimg.cc/NjMPzMs8/IMG-20251113-WA0000.jpg', event: 'day1' },
    { type: 'video', url: 'https://customer-assets.emergentagent.com/job_24dae199-66e7-4e77-8ffd-deeb363828c0/artifacts/rrvxnx14_VID-20251114-WA0011.mp4', alt: 'ویدیو همایش ۲۱ آبان', thumbnail: 'https://i.postimg.cc/9QFvHbpy/IMG-20251113-WA0001.jpg', event: 'day1' },
    { type: 'video', url: 'https://customer-assets.emergentagent.com/job_24dae199-66e7-4e77-8ffd-deeb363828c0/artifacts/kpbhttle_VID-20251114-WA0010.mp4', alt: 'ویدیو همایش ۲۱ آبان', thumbnail: 'https://i.postimg.cc/JzpCsvnq/IMG-20251113-WA0002.jpg', event: 'day1' },
    { type: 'video', url: 'https://customer-assets.emergentagent.com/job_24dae199-66e7-4e77-8ffd-deeb363828c0/artifacts/1xa38urk_VID-20251114-WA0007.mp4', alt: 'ویدیو همایش ۲۱ آبان', thumbnail: 'https://i.postimg.cc/jdQbbLrs/IMG-20251113-WA0003.jpg', event: 'day1' }
  ];

  const allImages = [...day1Images, ...day2Images, ...day3Images];
  const allMedia = [...allImages, ...eventVideos];
  const mediaLength = allMedia.length;

  const getFilteredMedia = () => {
    let filtered = allMedia;
    
    // Filter by event
    if (activeEvent !== 'all') {
      filtered = filtered.filter(item => item.event === activeEvent);
    }
    
    // Filter by type
    if (activeTab === 'images') {
      filtered = filtered.filter(item => item.type === 'image');
    } else if (activeTab === 'videos') {
      filtered = filtered.filter(item => item.type === 'video');
    }
    
    return filtered;
  };

  const handleMediaClick = (index) => {
    const filteredMedia = getFilteredMedia();
    const actualIndex = allMedia.findIndex(item => item.url === filteredMedia[index].url);
    setSelectedIndex(actualIndex);
    setLightboxOpen(true);
  };

  const handleNext = useCallback(() => {
    setSelectedIndex((prev) => (prev + 1) % mediaLength);
  }, [mediaLength]);

  const handlePrevious = useCallback(() => {
    setSelectedIndex((prev) => (prev - 1 + mediaLength) % mediaLength);
  }, [mediaLength]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!lightboxOpen) return;
      if (e.key === 'Escape') setLightboxOpen(false);
      if (e.key === 'ArrowRight') handlePrevious();
      if (e.key === 'ArrowLeft') handleNext();
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [lightboxOpen, handleNext, handlePrevious]);

  useEffect(() => {
    if (lightboxOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [lightboxOpen]);

  const filteredMedia = getFilteredMedia();
  const currentItem = allMedia[selectedIndex];

  // Event cards data
  const events = [
    {
      id: 'day1',
      title: 'همایش افتتاحیه جشنواره امید',
      date: '۲۱ آبان ۱۴۰۴',
      imageCount: day1Images.length,
      videoCount: eventVideos.filter(v => v.event === 'day1').length,
      gradient: 'from-purple-600 via-pink-600 to-rose-600',
      icon: '🎯'
    },
    {
      id: 'day2',
      title: 'روز دوم ثبت کمپ باور',
      date: '۲۸ آبان ۱۴۰۴',
      imageCount: day2Images.length,
      videoCount: eventVideos.filter(v => v.event === 'day2').length,
      gradient: 'from-blue-600 via-cyan-600 to-teal-600',
      icon: '🚀'
    },
    {
      id: 'day3',
      title: 'کمپ و اختتامیه جشنواره',
      date: '۱۲ آذر ۱۴۰۴',
      imageCount: day3Images.length,
      videoCount: eventVideos.filter(v => v.event === 'day3').length,
      gradient: 'from-emerald-600 via-green-600 to-teal-600',
      icon: '🏆'
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-purple-50/30 to-pink-50/30 dark:from-gray-900 dark:via-gray-800 dark:to-gray-900 transition-colors duration-300 py-8">
      <Helmet>
        <title>گالری تصاویر و ویدیوها | جشنواره امید</title>
        <meta name="description" content="تصاویر و ویدیوهای همایش‌های جشنواره امید" />
      </Helmet>

      <div className="container mx-auto px-4">
        {/* Header with Back Button */}
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          className="mb-8"
        >
          <button
            onClick={() => navigate('/festival')}
            className="flex items-center gap-2 text-purple-700 dark:text-purple-400 hover:text-purple-900 dark:hover:text-purple-300 font-bold transition-colors mb-6"
            data-testid="back-to-festival-btn"
          >
            <FaArrowRight className="text-xl" />
            بازگشت به صفحه جشنواره
          </button>

          <div className="text-center">
            <motion.div
              initial={{ scale: 0.9 }}
              animate={{ scale: 1 }}
              transition={{ duration: 0.5 }}
              className="inline-block mb-4"
            >
              <div className="inline-flex items-center gap-3 bg-gradient-to-r from-purple-600 via-pink-600 to-rose-600 text-white px-8 py-4 rounded-2xl shadow-2xl shadow-purple-500/30">
                <FaImage className="text-3xl" />
                <h1 className="text-2xl md:text-3xl lg:text-4xl font-black">گالری تصاویر و ویدیوها</h1>
              </div>
            </motion.div>
            <p className="text-base md:text-lg text-gray-700 dark:text-gray-300">
              خاطرات زیبای جشنواره امید
            </p>
          </div>
        </motion.div>

        {/* Event Cards */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1 }}
          className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8"
        >
          {events.map((event, index) => (
            <motion.div
              key={event.id}
              initial={{ opacity: 0, x: index === 0 ? -20 : 20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.2 + index * 0.1 }}
              onClick={() => setActiveEvent(activeEvent === event.id ? 'all' : event.id)}
              className={`relative overflow-hidden rounded-2xl cursor-pointer group transition-all duration-300 ${
                activeEvent === event.id 
                  ? 'ring-4 ring-purple-500 ring-offset-4 ring-offset-white dark:ring-offset-gray-900 scale-[1.02]' 
                  : 'hover:scale-[1.02]'
              }`}
            >
              <div className={`bg-gradient-to-br ${event.gradient} p-6 text-white`}>
                <div className="flex items-start justify-between">
                  <div>
                    <span className="text-4xl mb-3 block">{event.icon}</span>
                    <h3 className="text-xl md:text-2xl font-bold mb-2">{event.title}</h3>
                    <div className="flex items-center gap-2 text-white/80 mb-4">
                      <FaCalendarAlt />
                      <span className="font-medium">{event.date}</span>
                    </div>
                    <div className="flex gap-4">
                      <div className="bg-white/20 backdrop-blur-sm rounded-xl px-4 py-2">
                        <span className="text-2xl font-bold">{event.imageCount}</span>
                        <span className="text-sm mr-1">تصویر</span>
                      </div>
                      {event.videoCount > 0 && (
                        <div className="bg-white/20 backdrop-blur-sm rounded-xl px-4 py-2">
                          <span className="text-2xl font-bold">{event.videoCount}</span>
                          <span className="text-sm mr-1">ویدیو</span>
                        </div>
                      )}
                    </div>
                  </div>
                  {activeEvent === event.id && (
                    <motion.div
                      initial={{ scale: 0 }}
                      animate={{ scale: 1 }}
                      className="bg-white text-purple-600 rounded-full p-2"
                    >
                      <FaFilter />
                    </motion.div>
                  )}
                </div>
                {/* Decorative elements */}
                <div className="absolute -bottom-8 -right-8 w-32 h-32 bg-white/10 rounded-full" />
                <div className="absolute -top-4 -left-4 w-24 h-24 bg-white/10 rounded-full" />
              </div>
            </motion.div>
          ))}
        </motion.div>

        {/* Active Event Indicator */}
        {activeEvent !== 'all' && (
          <motion.div
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            className="flex justify-center mb-6"
          >
            <div className="inline-flex items-center gap-2 bg-purple-100 dark:bg-purple-900/30 text-purple-700 dark:text-purple-300 px-4 py-2 rounded-xl">
              <FaFilter className="text-sm" />
              <span className="font-medium">
                فیلتر شده: {events.find(e => e.id === activeEvent)?.title}
              </span>
              <button
                onClick={() => setActiveEvent('all')}
                className="mr-2 p-1 hover:bg-purple-200 dark:hover:bg-purple-800 rounded-full transition-colors"
              >
                <FaTimes className="text-sm" />
              </button>
            </div>
          </motion.div>
        )}

        {/* Filter Tabs */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
          className="flex justify-center gap-3 mb-8 flex-wrap"
        >
          <button
            onClick={() => setActiveTab('all')}
            className={`px-6 py-3 rounded-xl font-bold transition-all duration-300 ${
              activeTab === 'all'
                ? 'bg-gradient-to-r from-purple-600 to-pink-600 text-white shadow-lg shadow-purple-500/30 scale-105'
                : 'bg-white/80 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-purple-100 dark:hover:bg-gray-600 shadow-md'
            }`}
            data-testid="filter-all-btn"
          >
            همه ({filteredMedia.length})
          </button>
          <button
            onClick={() => setActiveTab('images')}
            className={`flex items-center gap-2 px-6 py-3 rounded-xl font-bold transition-all duration-300 ${
              activeTab === 'images'
                ? 'bg-gradient-to-r from-blue-600 to-cyan-600 text-white shadow-lg shadow-blue-500/30 scale-105'
                : 'bg-white/80 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-blue-100 dark:hover:bg-gray-600 shadow-md'
            }`}
            data-testid="filter-images-btn"
          >
            <FaImage />
            تصاویر ({filteredMedia.filter(m => m.type === 'image').length})
          </button>
          <button
            onClick={() => setActiveTab('videos')}
            className={`flex items-center gap-2 px-6 py-3 rounded-xl font-bold transition-all duration-300 ${
              activeTab === 'videos'
                ? 'bg-gradient-to-r from-red-600 to-rose-600 text-white shadow-lg shadow-red-500/30 scale-105'
                : 'bg-white/80 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-red-100 dark:hover:bg-gray-600 shadow-md'
            }`}
            data-testid="filter-videos-btn"
          >
            <FaVideo />
            ویدیوها ({filteredMedia.filter(m => m.type === 'video').length})
          </button>
        </motion.div>

        {/* Gallery Grid - Masonry-like Layout */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4 }}
          className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4"
        >
          <AnimatePresence mode="popLayout">
            {filteredMedia.map((item, index) => (
              <motion.div
                key={`${item.url}-${index}`}
                layout
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.8 }}
                transition={{ duration: 0.3, delay: index * 0.02 }}
                whileHover={{ scale: 1.05, y: -5, zIndex: 10 }}
                onClick={() => handleMediaClick(index)}
                className={`relative cursor-pointer group overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 ${
                  index % 7 === 0 ? 'row-span-2 aspect-[3/4]' : 'aspect-square'
                }`}
                data-testid={`gallery-item-${index}`}
              >
                {item.type === 'image' ? (
                  <>
                    <img
                      src={item.url}
                      alt={item.alt}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                      loading="lazy"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                    {/* Event Badge */}
                    <div className={`absolute top-2 right-2 px-2 py-1 rounded-lg text-xs font-bold backdrop-blur-md ${
                      item.event === 'day1' 
                        ? 'bg-purple-600/90 text-white' 
                        : item.event === 'day2' 
                        ? 'bg-blue-600/90 text-white'
                        : 'bg-emerald-600/90 text-white'
                    }`}>
                      {item.event === 'day1' ? '۲۱ آبان' : item.event === 'day2' ? '۲۸ آبان' : '۱۲ آذر'}
                    </div>
                  </>
                ) : (
                  <>
                    <video
                      src={item.url}
                      className="w-full h-full object-cover"
                      preload="metadata"
                    />
                    <div className="absolute inset-0 bg-black/50 group-hover:bg-black/70 transition-colors duration-300 flex items-center justify-center">
                      <div className="bg-white/20 backdrop-blur-md rounded-full p-4 md:p-5 transform scale-90 group-hover:scale-100 transition-transform duration-300">
                        <FaPlay className="text-white text-2xl md:text-3xl mr-1" />
                      </div>
                    </div>
                    <div className="absolute top-2 right-2 bg-red-600/90 backdrop-blur-sm text-white px-2 py-1 rounded-lg text-xs font-bold flex items-center gap-1">
                      <FaVideo className="text-xs" />
                      ویدیو
                    </div>
                  </>
                )}
              </motion.div>
            ))}
          </AnimatePresence>
        </motion.div>

        {/* Stats Footer */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.6 }}
          className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-4"
        >
          <div className="bg-white/80 dark:bg-gray-700/80 backdrop-blur-sm rounded-2xl p-6 shadow-xl text-center">
            <div className="text-4xl font-black text-purple-600 dark:text-purple-400 mb-1">{allMedia.length}</div>
            <div className="text-gray-600 dark:text-gray-400 font-medium">کل رسانه‌ها</div>
          </div>
          <div className="bg-white/80 dark:bg-gray-700/80 backdrop-blur-sm rounded-2xl p-6 shadow-xl text-center">
            <div className="text-4xl font-black text-blue-600 dark:text-blue-400 mb-1">{allImages.length}</div>
            <div className="text-gray-600 dark:text-gray-400 font-medium">تصویر</div>
          </div>
          <div className="bg-white/80 dark:bg-gray-700/80 backdrop-blur-sm rounded-2xl p-6 shadow-xl text-center">
            <div className="text-4xl font-black text-pink-600 dark:text-pink-400 mb-1">{eventVideos.length}</div>
            <div className="text-gray-600 dark:text-gray-400 font-medium">ویدیو</div>
          </div>
          <div className="bg-white/80 dark:bg-gray-700/80 backdrop-blur-sm rounded-2xl p-6 shadow-xl text-center">
            <div className="text-4xl font-black text-emerald-600 dark:text-emerald-400 mb-1">{events.length}</div>
            <div className="text-gray-600 dark:text-gray-400 font-medium">رویداد</div>
          </div>
        </motion.div>
      </div>

      {/* Lightbox */}
      <AnimatePresence>
        {lightboxOpen && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-50 flex items-center justify-center bg-black/95 backdrop-blur-sm"
            onClick={() => setLightboxOpen(false)}
          >
            {/* Close Button */}
            <motion.button
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              onClick={() => setLightboxOpen(false)}
              className="absolute top-4 right-4 z-50 p-4 bg-white/10 hover:bg-white/20 backdrop-blur-md rounded-full text-white transition-all shadow-lg"
              data-testid="lightbox-close-btn"
            >
              <FaTimes className="text-2xl" />
            </motion.button>

            {/* Counter */}
            <motion.div
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              className="absolute top-4 left-1/2 transform -translate-x-1/2 z-50 px-6 py-2 bg-white/10 backdrop-blur-md rounded-full text-white font-bold text-lg"
            >
              {selectedIndex + 1} / {allMedia.length}
            </motion.div>

            {/* Navigation */}
            {allMedia.length > 1 && (
              <>
                <motion.button
                  initial={{ opacity: 0, x: 20 }}
                  animate={{ opacity: 1, x: 0 }}
                  onClick={(e) => {
                    e.stopPropagation();
                    handlePrevious();
                  }}
                  className="absolute right-4 top-1/2 transform -translate-y-1/2 z-50 p-4 bg-white/10 hover:bg-white/20 backdrop-blur-md rounded-full text-white transition-all shadow-lg"
                  data-testid="lightbox-prev-btn"
                >
                  <FaChevronRight className="text-2xl" />
                </motion.button>

                <motion.button
                  initial={{ opacity: 0, x: -20 }}
                  animate={{ opacity: 1, x: 0 }}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleNext();
                  }}
                  className="absolute left-4 top-1/2 transform -translate-y-1/2 z-50 p-4 bg-white/10 hover:bg-white/20 backdrop-blur-md rounded-full text-white transition-all shadow-lg"
                  data-testid="lightbox-next-btn"
                >
                  <FaChevronLeft className="text-2xl" />
                </motion.button>
              </>
            )}

            {/* Content */}
            <motion.div
              key={selectedIndex}
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.9 }}
              transition={{ duration: 0.3 }}
              onClick={(e) => e.stopPropagation()}
              className="relative max-w-7xl max-h-[90vh] w-full mx-4 flex items-center justify-center"
            >
              {currentItem.type === 'image' ? (
                <img
                  src={currentItem.url}
                  alt={currentItem.alt || `تصویر ${selectedIndex + 1}`}
                  className="max-w-full max-h-[90vh] object-contain rounded-lg shadow-2xl"
                />
              ) : (
                <video
                  src={currentItem.url}
                  controls
                  autoPlay
                  className="max-w-full max-h-[90vh] object-contain rounded-lg shadow-2xl"
                >
                  مرورگر شما از پخش ویدیو پشتیبانی نمی‌کند.
                </video>
              )}
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

export default GalleryPage;